export default {
  clientesPerdidos: {},
  unidades: [],
  faturamento: {},
  cupons: {},
  cuponsLastYear: {},
  faturamentoDta: {},
  ticketMedio: {},
  ticketMedioForaClube: {},
  clientesCadastrados: {},
  clientesAtivos: {},
  percentualFaturamentoFidelidade: {},
  mariaPercentualFaturamentoFidelidade: {},
  ticketMedioFidelidade: {},
  percentualTicketMedioFidelidade: {},
  percentualTicketMedioFidelidadeMesAnterior: {},
  mediaComprasFidelidade: {},
  mediaComprasFidelidadeAnoAnterior: {},
  gastoMedioFidelidade: {},
  gastoMedioFidelidadeAnoAnterior: {},
  totalClientesCadastrados: null,
  primeiroValorCadastrosTotal: null,
  primeiroValorCadastrosOntem: null,
  primeiroValorSemanaAtual: null,
  primeiroValorMesAtual: null,
  primeiroValorPerfilDemografico: null,
  homeOpportunities: {},
  homeConsumersDistribution: {},
}
